import {
  ToggleVectorTileInSettings,
  useVectorTileSettings,
} from '../../../VectorTiles/useVectorTileSettings';
import React, { useState } from 'react';
import { useLayers } from '@ais-ui/react-openlayers';
import {
  Button,
  Command,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  Popover,
  PopoverContent,
  PopoverTrigger,
  ScrollArea,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  useToast,
} from '@ais-ui/ui-core';
import { PiGridFourThin } from 'react-icons/pi';
import { useSaveSettings, VectorTile } from '@ais-ui/websockets';
import { useSettings } from '../../../Settings/SettingsProvider';
import { useLocalization } from '@ais-ui/locale-management';
import { CheckIcon } from '@radix-ui/react-icons';
import { EmptyCommand } from '../../../../components/EmptyCommand';
import { ROUTES } from '../../../../routes';

export const VectorTiles = () => {
  const { messages } = useLocalization();
  const { settings } = useSettings();
  const vectorTiles = useVectorTileSettings();
  const [open, setOpen] = useState(false);
  const { toast } = useToast();
  const { removeLayer, getLayerById, doesLayerExist, addVectorTile } =
    useLayers();
  const { mutate: mutateSettings } = useSaveSettings();

  const onVectorTileSelect = (vectorTile: VectorTile) => {
    const enable = !doesLayerExist(vectorTile.id);
    const settingsToSave = ToggleVectorTileInSettings(
      vectorTiles,
      vectorTile.id,
      enable,
      settings
    );

    if (enable) {
      addVectorTile(vectorTile, true, vectorTile.id);
    } else {
      const layerItem = getLayerById(vectorTile.id);
      if (!layerItem) {
        return;
      }
      removeLayer(layerItem.layer);
    }

    mutateSettings(settingsToSave, {
      onSuccess: () => {
        toast({
          className: 'enable-vector-tile-success-toast',
          title: messages.genericToastTitleSuccess,
          description: enable
            ? messages.mapMenuVectorTilesEnabledLayer.replace(
                '{label}',
                vectorTile.name
              )
            : messages.mapMenuVectorTilesDisabledLayer.replace(
                '{label}',
                vectorTile.name
              ),
        });
      },
      onError: () => {
        toast({
          className: 'enable-vector-tile-error-toast',
          title: messages.genericToastTitleError,
          description: enable
            ? messages.mapMenuVectorTilesFailedToEnableLayer.replace(
                '{label}',
                vectorTile.name
              )
            : messages.mapMenuVectorTilesFailedToDisableLayer.replace(
                '{label}',
                vectorTile.name
              ),
          variant: 'destructive',
        });
      },
    });

    setOpen(false);
  };

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <Button
                id="vector-tiles-button"
                size="icon"
                variant="outline"
                className="h-10 w-10 flex-shrink-0 flex-grow-0"
              >
                <PiGridFourThin className="h-7 w-7" />
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent>Add Vector Tiles</TooltipContent>
        </Tooltip>
        <PopoverContent>
          {vectorTiles && vectorTiles.length === 0 ? (
            <EmptyCommand
              entity="vector tile"
              srcImage="empty_list_bro.png"
              to={ROUTES.SETTINGS.VECTOR_TILES.path}
            />
          ) : (
            <Command>
              <CommandInput placeholder="Find Vector tile..." />
              <CommandList className="overflow-hidden h-60">
                <ScrollArea className="flex-grow overflow-y-auto pr-4 h-60">
                  <CommandGroup heading="Vector Tiles">
                    {vectorTiles.map((vectorTile, index) => (
                      <CommandItem
                        key={vectorTile.id}
                        value={`${vectorTile.name}__${index}`}
                        onSelect={() => onVectorTileSelect(vectorTile)}
                      >
                        <div className="flex justify-between w-full">
                          <div>{vectorTile.name}</div>
                          {doesLayerExist(vectorTile.id) && (
                            <CheckIcon className="h-4 w-4" />
                          )}
                        </div>
                      </CommandItem>
                    ))}
                  </CommandGroup>
                </ScrollArea>
              </CommandList>
            </Command>
          )}
        </PopoverContent>
      </Popover>
      {/*{vectorTileHoverState.feature && (*/}
      {/*  <VectorTilePopover*/}
      {/*    feature={vectorTileHoverState.feature}*/}
      {/*    position={vectorTileHoverState.position}*/}
      {/*  />*/}
      {/*)}*/}
    </>
  );
};
